export default "__VITE_ASSET__OrsE79_h__"